import { combineReducers } from "redux";
import appReducer from "./appReducer";
import surveyReducer from "./surveyReducer";
import statsReducer from "./../../modules/stats/reducers/statsReducer";
import planningReducer from "./planningReducer";
import clientReducer from "./clientReducer";
import userReducer from "./userReducer";
import authReducer from "./authReducer";
import photothequeReducer from "./photothequeReducer";
import visitReducer from "./visitReducer";
import logReducer from "./logReducer";
import userInfosReducer from "./userInfosReducer";
import currentClientReducer from "./currentClientReducer";
import modelsReducer from "./modelsReducer";
import commercialReducer from "./commercialReducer";
import sectorsReducer from "./sectorsReducer";
import allSectorsReducer from "./allSectorsReducer";
import kpisReducer from "./kpisReducer";
import actionsReducer from "./actionsReducer";
import iocsReducer from "./iocsReducer";
import networksReducer from "./networksReducer";
import clientsReducer from "./clientsReducer";
import typologiesReducer from "./typologiesReducer";
import propertiesReducer from "./propertiesReducer";
import pdcsReducer from "./pdcsReducer";
import presenceReducer from "./../../modules/presence/reducers/presence";
import presenceDetailsDayReducer from "./../../modules/presence/reducers/presenceDetailsDay";
import presenceDetailsWeekReducer from "../../modules/presence/reducers/presenceDetailsWeek";
import expenseReportsReducer from "./../../modules/presence/reducers/expenseReports";
import premiumReducer from "./premiumReducer";
import usersSectorsListReducer from "./usersSectorsReducer";
import transfersReducer from "../../modules/presence/reducers/transfers";
import absenceTypesReducer from "./absenceTypesReducer"

import { intlReducer } from "react-intl-redux";
const rootReducer = combineReducers({
  app: appReducer,
  survey: surveyReducer,
  client: clientReducer,
  planning: planningReducer,
  user: userReducer,
  auth: authReducer,
  phototheque: photothequeReducer,
  visit: visitReducer,
  log: logReducer,
  stats: statsReducer,
  userInfos: userInfosReducer,
  currentClient: currentClientReducer,
  models: modelsReducer,
  commercial: commercialReducer,
  sectors: sectorsReducer,
  allSectors: allSectorsReducer,
  kpis: kpisReducer,
  actions: actionsReducer,
  iocs: iocsReducer,
  networks: networksReducer,
  clients: clientsReducer,
  typologies: typologiesReducer,
  properties: propertiesReducer,
  pdcs: pdcsReducer,
  intl: intlReducer,
  presence: presenceReducer,
  presenceDetailsDay: presenceDetailsDayReducer,
  presenceDetailsWeek: presenceDetailsWeekReducer,
  expenseReports: expenseReportsReducer,
  premium: premiumReducer,
  usersSectors: usersSectorsListReducer,
  transfers: transfersReducer,
  absenceTypes: absenceTypesReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// src/redux/reducers/index.js